import { Children, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Divider, Dropdown, Label, List } from "semantic-ui-react";
import { restRequest } from "../../http";
import { DropdownOption } from "../../models/testing_model";

export function TestingDataMenu(props: {selectedText?: string, options?: DropdownOption[], dashboardMenu?: boolean}) {
    const sAllDropdownOptions = useState<DropdownOption[]>([]);
    const sFilteredDropdownOptions = useState<DropdownOption[]>([]);
    const sSearchQuery = useState('');

    useEffect(() => {
        if (props.options) {
            sAllDropdownOptions[1](props.options);
            sFilteredDropdownOptions[1](props.options);
        } else {
            restRequest<DropdownOption[]>('svn_repository/result_dropdown_options').then(s => {
                sAllDropdownOptions[1](s);
                sFilteredDropdownOptions[1](s);
            })
        }
    }, [props.options]);

    useEffect(() => {
        if (!sSearchQuery[0].trim()) {
            sFilteredDropdownOptions[1](sAllDropdownOptions[0]);
            return;
        }
        const searchString = sSearchQuery[0].trim().toLowerCase().split(' ').filter(v => v.trim()).slice(0, 3);

        sFilteredDropdownOptions[1](filter(sAllDropdownOptions[0], searchString, 0, 0))
    }, [sSearchQuery[0]]);

    const toPage = props.dashboardMenu ? (window.location.pathname.includes('/detail') ? 'detail' : 'overview') : 'overview';
    
    return <Dropdown item className="mini" compact text={props.selectedText || 'Testing Data'} scrolling search button={props.dashboardMenu} onSearchChange={(e, d) => {
        let query = d.searchQuery as string || '';
        sSearchQuery[1](query);
    }} searchQuery={sSearchQuery[0]}>
        <Dropdown.Menu style={{padding: '1rem'}}>
            <List>
                {sFilteredDropdownOptions[0].map((p, pi) => <List.Item key={p.id} attached={pi === 0 ? 'bottom' : undefined}>
                    <List.Header><h5>{p.name}</h5></List.Header>
                    <List.Description>
                        <List.List size="mini">
                        {p.children.map(s => <List.Item key={s.id} size="mini" style={{padding: '3px'}}>
                                    <List.Description>
                                        <b>{s.name}: </b>{s.children.map(o => <NavLink key={o.id} style={{ margin: '5px'}} target={props.dashboardMenu ? undefined : '_blank'} to={`/testing_visual/${o.id}/${toPage}`}>{o.name}</NavLink>)}
                                    </List.Description>
                                </List.Item>)}
                        </List.List>
                    </List.Description>
                </List.Item>)}
            </List>
        </Dropdown.Menu>
    </Dropdown>
}


export function TestingDataDropdown(props: {name: string, value: number, options: DropdownOption[], onChange: (e: any, d: any) => void, placeholder?: string}) {
    const {name, value, options, onChange, placeholder} = props;

    let selectedTestingResult = placeholder || 'Please Select';
    if (value) {
        out: for (const p of options) {
            for (const s of p.children) {
                for (const o of s.children) {
                    if (o.id === value) {
                        selectedTestingResult = `${p.name} -> ${s.name} -> ${o.name}`;
                        (window as any).test_info = {product: p.name, order: s.name}
                        window.document.title = selectedTestingResult;
                        break out;
                    }
                }
            }
        }
    }

    const sAllDropdownOptions = useState<DropdownOption[]>(props.options || []);
    const sFilteredDropdownOptions = useState<DropdownOption[]>(props.options || []);
    const sSearchQuery = useState('');

    useEffect(() => {
        sAllDropdownOptions[1](props.options);
        sFilteredDropdownOptions[1](props.options);
    }, [props.options]);

    useEffect(() => {
        if (!sSearchQuery[0].trim()) {
            sFilteredDropdownOptions[1](sAllDropdownOptions[0]);
            return;
        }
        const searchString = sSearchQuery[0].trim().toLowerCase().split(' ').filter(v => v.trim()).slice(0, 3);

        sFilteredDropdownOptions[1](filter(sAllDropdownOptions[0], searchString, 0, 0))
    }, [sSearchQuery[0]]);
    
    return <Dropdown item compact text={selectedTestingResult} scrolling search onSearchChange={(e, d) => {
        let query = d.searchQuery as string || '';
        sSearchQuery[1](query);
    }} searchQuery={sSearchQuery[0]}>
        <Dropdown.Menu style={{padding: '1rem'}}>
            <List>
                {sFilteredDropdownOptions[0].map((p, pi) => <List.Item key={p.id} basic attached={pi === 0 ? 'bottom' : undefined}>
                    <List.Header><h5>{p.name}</h5></List.Header>
                    <List.Description>
                        <List.List size="mini">
                        {p.children.map(s => <List.Item key={s.id} basic compact size="mini" style={{padding: '3px'}}>
                                    <List.Description>
                                        <b>{s.name}: </b>{s.children.map(o => <Label as="a" key={o.id} style={{ margin: '5px'}} onClick={e => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            onChange(null, {name, value: o.id});
                                            sSearchQuery[1]('')
                                        }}>{o.name}</Label>)}
                                    </List.Description>
                                </List.Item>)}
                        </List.List>
                    </List.Description>
                </List.Item>)}
            </List>
        </Dropdown.Menu>
    </Dropdown>
}

function filter(options: DropdownOption[], queries: string[], level: number, matchedCount: number): DropdownOption[] {
    if (matchedCount >= queries.length) {
        return options;
    }
    return options.map(o => {
        if (o.name.toLowerCase().includes(queries[Math.min(level, queries.length - 1)])) {
            return {...o, children: o.children && o.children.length > 0 ? filter(o.children, queries, level + 1, matchedCount + 1) : []}
        } else {
            const children = o.children && o.children.length > 0 ? filter(o.children, queries, level, matchedCount) : [];
            if (children.length > 0) {
                return {...o, children}
            }
            
            return null;
        }
    }).filter((o, i) => !!o && (o.children && o.children.length > 0 || (!options[i].children || options[i].children.length === 0))) as any;
}